export default "__VITE_ASSET__T535vBxU__"